import React, { ComponentType, lazy, Suspense } from 'react';

type TAsyncModule<TProps extends object> = {
    default: ComponentType<TProps>;
};

type TAsyncImport<TProps extends object> = () => Promise<TAsyncModule<TProps>>;

export const withAsyncImport = <TProps extends object>(
    asyncImport: TAsyncImport<TProps>,
): ComponentType<TProps> => {
    const LazyComponent = lazy(() => asyncImport());

    return function AsyncComponent(props: TProps) {
        return React.createElement(
            Suspense,
            { fallback: null },
            React.createElement(LazyComponent, props),
        );
    };
};

export default withAsyncImport;
